import { IValidatedMeControlConfiguration } from '@mecontrol/common';

let _options: IValidatedMeControlConfiguration | undefined;

/** Gets the MeControl options */
export function getOptions(): IValidatedMeControlConfiguration | undefined {
    return _options;
}

export function setOptions(opts: IValidatedMeControlConfiguration | undefined): void {
    _options = opts;
}
